// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#708238',
            light: '#A8B97C',
            dark: '#556B2F',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#DAD3C1',
            light: '#F8F7F2',
            dark: '#A8B97C',
            contrastText: '#3B3B3B',
        },
        background: {
            default: '#F8F7F2',
            paper: '#ffffff',
        },
        text: {
            primary: '#3B3B3B',
            secondary: '#556B2F',
        },
        error: {
            main: '#B3261E',
            dark: '#8C1D16',
            contrastText: '#fff',
        },
        info: {
            main: '#1E4F91',
            dark: '#163D73',
            contrastText: '#fff',
        },
        success: {
            main: '#A8B97C',
        },
        divider: '#DAD3C1',
    },
    typography: {
        fontFamily: 'Poppins, sans-serif',
        h4: {
            fontWeight: 700,
            fontSize: '2rem',
            color: '#3B3B3B',
        },
        h5: {
            fontWeight: 600,
            fontSize: '1.5rem',
            color: '#3B3B3B',
        },
        h6: {
            fontWeight: 600,
            fontSize: '1.2rem',
            color: '#3B3B3B',
        },
        subtitle1: {
            fontWeight: 600,
            color: '#3B3B3B',
        },
        button: {
            textTransform: 'none',
            fontWeight: 'bold',
        },
        body2: {
            color: '#556B2F',
        },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    padding: '10px 16px',
                    fontWeight: 'bold',
                    fontSize: '0.95rem',
                },
                containedPrimary: {
                    backgroundColor: '#708238',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#556B2F',
                    },
                },
                outlinedPrimary: {
                    borderColor: '#708238',
                    color: '#708238',
                    '&:hover': {
                        backgroundColor: '#F8F7F2',
                        borderColor: '#556B2F',
                        color: '#556B2F',
                    },
                },
                containedError: {
                    backgroundColor: '#B3261E',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#8C1D16',
                    },
                },
                outlinedSecondary: {
                    borderColor: '#A8B97C',
                    color: '#556B2F',
                    '&:hover': {
                        backgroundColor: '#F8F7F2',
                        borderColor: '#708238',
                        color: '#708238',
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 'bold',
                    backgroundColor: '#A8B97C',
                    color: '#3B3B3B',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#708238',
                    color: '#ffffff',
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: '#A8B97C',
                        '&:hover': {
                            backgroundColor: '#708238',
                            color: '#ffffff',
                        },
                    },
                    '&:hover': {
                        backgroundColor: '#DAD3C1',
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                body2: {
                    color: '#556B2F',
                },
                subtitle1: {
                    fontWeight: 600,
                    color: '#3B3B3B',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.06)',
                    // 🔥 Do NOT override borderRadius — respect theme.shape.borderRadius globally
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    borderRadius: 12,
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#3B3B3B',
                    fontWeight: 500,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#708238',
                    },
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F0F0E8',
                },
            },
        },
    },
});

export default theme;
